import {axios} from "../../lib/axios.js";
export const checkVariationBarcode = async (val, masterVariationId = "") => {
  return await axios.get(`/saas/master-variation/check-variation-barcode`, {
    params: {barcode: val, masterVariationId}
  });
};
export const checkVariationSku = async (val) => {
  return await axios.get(`/saas/master-variation/check-variation-sku`, {
    params: {sku: val}
  });
};
export const checkVariationSimilarSku = async (val) => {
  return await axios.get(`/saas/master-variation/check-variation-similar-sku`, {
    params: {sku: val}
  });
};
